import { VisionLinkExternalLinkProp } from '../../types';
import styles from '../../VisionLink.module.scss';
import { CatHeading } from '@blocks-react/components/Heading';



export const VisionLinkExternalLink = ({
  children
}: VisionLinkExternalLinkProp) => {
  return (
    <CatHeading variant="footnote"><span className={styles['note-field']}>{children}</span>
    </CatHeading>
  );
};
